/* ============================================================================
   facil. — PANIER TIROIR · colle JS GLOBALE
   ----------------------------------------------------------------------------
   Le moteur (ouverture, fermeture, focus-trap, Échap, AJAX qty/remove, Section
   Rendering) vient de cart-drawer.js + cart.js (Dawn, déjà chargés en cart_type
   drawer). Ici on définit <facil-add> AU NIVEAU GLOBAL : le tiroir (donc ses
   cartes cross-sell) est présent sur TOUTES les pages, alors que facil-product.js
   n'est chargé que sur la PDP. Garde-fou customElements.get → pas de double def.
   <facil-add> POST /cart/add.js avec sections= → cart-drawer.renderContents()
   re-render #CartDrawer ET ouvre le tiroir (ajout 1 clic, sans le fermer).
   ============================================================================ */
(function () {
  if (window.customElements && !customElements.get('facil-add')) {
    customElements.define(
      'facil-add',
      class FacilAdd extends HTMLElement {
        connectedCallback() {
          this.btn = this.querySelector('button');
          if (!this.btn) return;
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.btn.addEventListener('click', this.onClick.bind(this));
        }

        onClick(e) {
          e.preventDefault();
          var id = this.getAttribute('data-variant-id');
          if (!id || this.btn.getAttribute('aria-disabled') === 'true') return;

          this.btn.setAttribute('aria-disabled', 'true');
          this.btn.classList.add('loading');
          var spinner = this.btn.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');

          var config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: {} };
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          var fd = new FormData();
          fd.append('id', id);
          fd.append('quantity', '1');
          if (this.cart && this.cart.getSectionsToRender) {
            fd.append('sections', this.cart.getSectionsToRender().map(function (s) { return s.id; }));
            fd.append('sections_url', window.location.pathname);
            if (this.cart.setActiveElement) this.cart.setActiveElement(document.activeElement);
          }
          config.body = fd;

          var self = this;
          fetch(window.routes.cart_add_url, config)
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res.status) return; /* rupture / erreur : on ne casse rien */
              if (self.cart && self.cart.renderContents) {
                if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                  publish(PUB_SUB_EVENTS.cartUpdate, { source: 'facil-add', productVariantId: id, cartData: res });
                }
                self.cart.renderContents(res);
              } else {
                window.location = window.routes.cart_url;
              }
            })
            .catch(function (err) { console.error(err); })
            .finally(function () {
              self.btn.classList.remove('loading');
              self.btn.removeAttribute('aria-disabled');
              if (spinner) spinner.classList.add('hidden');
              if (self.cart && self.cart.classList.contains('is-empty')) self.cart.classList.remove('is-empty');
            });
        }
      }
    );
  }

  /* ---- Suppression du message d'erreur GLOBAL faux-positif ----
     Après l'ajout d'un bundle, l'app Simple Bundles fait un /cart/change pour éclater le pack.
     Ce /cart/change fait échouer un re-render de Dawn, qui écrit « Une erreur est survenue » dans
     #CartDrawer-CartErrors — alors que la commande est parfaitement correcte (vérifié au checkout).
     On observe CE conteneur et on le vide dès qu'il se remplit, à tout moment (l'app réécrit le
     message APRÈS l'ouverture du tiroir, d'où l'observation continue et non ponctuelle).
     On ne touche QU'au message global : les erreurs par produit (rupture) sont des éléments
     distincts (.cart-item__error-text) et restent affichées. */
  (function () {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !('MutationObserver' in window)) return;
    function clearGlobalError() {
      var el = drawer.querySelector('#CartDrawer-CartErrors');
      if (el && el.textContent.trim() !== '') el.textContent = '';
    }
    new MutationObserver(clearGlobalError).observe(drawer, { childList: true, subtree: true, characterData: true });
    clearGlobalError();
  })();
})();
